import { PauseCircle } from "lucide-react"

import { StatusBadge } from "../ui/status-badge"

// The small inline "set aside" pill for a config parked out of the run
// (`nova runs set-aside`). A parked config keeps its last verdict and still gets
// a card, so without this it reads as an OK product whose copy went missing —
// which is exactly what a parked-before-copy config looks like.
//
// Muted, not warning-toned: parking is a decision already taken, not an action
// waiting on the reader. The operator's reason rides in the tooltip, so "why is
// this one empty?" is answerable without leaving the page.
export function SetAsidePill({ reason }: { reason: string | null }) {
  return (
    <StatusBadge
      tone="muted"
      size="sm"
      title={reason ? `Set aside: ${reason}` : "Set aside from this run"}
    >
      <PauseCircle className="size-3" />

      <span>set aside</span>
    </StatusBadge>
  )
}
